import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Settings } from 'lucide-react';
import { Button } from '../../ui/Button';
import { navigate } from '../../../App';

/**
 * Sticky top bar shown on every store page.
 * Left (RTL: right): teaser that links visitors back to the Mekomit home page.
 * Right (RTL: left): admin entry (visible only to owners / co-admins).
 */
export function StoreTopBar({ isAdmin, onAdminClick }) {
    return (
        <header className="fixed top-0 left-0 right-0 z-nav bg-surface/95 backdrop-blur border-b border-line-subtle shadow-xs safe-top">
            <div className="max-w-5xl mx-auto flex items-center justify-between gap-2 px-4 py-2">
                <motion.button
                    type="button"
                    onClick={() => navigate('home')}
                    aria-label="חזרה לדף הבית של המקומית"
                    initial={{ opacity: 0, y: -4 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: 0.1, ease: [0.32, 0.72, 0, 1] }}
                    className="flex items-center gap-1.5 min-w-0 px-2.5 py-1 rounded-pill bg-secondary-50/70 border border-secondary-100/80 shadow-xs hover:bg-secondary-100/80 hover:border-secondary-200 hover:shadow-sm active:scale-[0.97] transition-[background-color,border-color,box-shadow,transform] duration-200 ease-smooth focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-300 focus-visible:ring-offset-1 focus-visible:ring-offset-surface"
                >
                    <span className="text-[11px] sm:text-xs font-medium leading-tight whitespace-nowrap text-secondary-700">
                        גלו את המקומית
                    </span>
                    <motion.span
                        animate={{ x: [0, -3, 0] }}
                        transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
                        className="shrink-0 flex"
                        aria-hidden="true"
                    >
                        <ArrowLeft className="w-3.5 h-3.5 text-secondary-600" />
                    </motion.span>
                </motion.button>

                {isAdmin && (
                    <Button
                        size="sm"
                        variant="subtle"
                        icon={<Settings className="transition-transform group-hover:rotate-90 duration-300" />}
                        onClick={onAdminClick}
                        className="group shrink-0"
                    >
                        ניהול חנות
                    </Button>
                )}
            </div>
        </header>
    );
}

export default StoreTopBar;
